module.exports = __webpack_public_path__ + "img/TZS09648.6e4d98ad.jpeg";